import Typography from '@mui/material/Typography';
import Layout from '../components/Layout';
import UsersConsole from '../components/UsersConsole';
import { useI18n } from '../i18n';

export default function Admin() {
  const { t } = useI18n();
  return (
    <Layout>
      <Typography variant="h5" sx={{ mb: 1.5 }}>{t('usersConsole.title')}</Typography>
      <UsersConsole />
    </Layout>
  );
}
